module.exports = "/_next/static/images/bdb0cad5a677b83094d821d6713cc8d1-payment_delay_gray.png.webp";